import React from 'react'
import { Row, Col, Card, Table, Tag, Button, Badge, Empty, Image } from 'antd'
import { Moment } from '../../../helpers'
import './style.scss'
import { inject, observer } from 'mobx-react'
import 'react-fancybox/lib/fancybox.css'
import { JobStatus } from '../../job/JobStatus'
import { JobDateTime } from '../../job/JobDateTime'
import { JobItem } from '../../job/JobItem'
import { InformfixStatus } from '../../informfix/InformfixStatus'


const IconText = ({ type, text }) => <span>{text}</span>
const formatTime = 'HH:mm'

@inject('informStore')
@observer
class InformView extends React.Component {
  state = {
    visibleGallery: false,
  }

  setVisibleGallery(value) {
    this.setState({
      visibleGallery: value,
    })
  }

  componentDidMount() {}

  render() {
    const { home, jobs, item, photos } = this.props
    const { visibleGallery } = this.state

    // ชื่อช่าง
    const technicianName = (job) => {
      if (job.technicians && job.technicians.length > 0) {
        let name = ''
        let names = []
        job.technicians.map((v, tkey) => {
          if (v.technician) {
            if (v.technician) {
              names.push(
                <Tag key={tkey} color="">
                  ช่าง: {v.technician.firstname}
                </Tag>,
              )
            }
          }
        })
        return names
      }
    }

    // แสดงวันที่ from unix timestamp
    const showTimeFromUnix = (datetime) => {
      let date = Moment.unix(datetime)
      if (date.isValid()) {
        return date.format('lll น.')
      } else {
        return
      }
    }
    // แสดงวันที่
    const showTime = (datetime) => {
      let date = Moment(datetime)
      if (date.isValid()) {
        return date.format('lll น.')
      } else {
        return
      }
    }

    const showDetail = (record) => {
      return (
        <div
          style={{
            marginLeft: 20,
            fontSize: '12px',
          }}
        >
          {record.informFix ? (
            <div>
              <IconText type="bank" text={record.informFix.project.name} />
            </div>
          ) : null}

          {record.informFix ? (
            <div>
              <IconText
                type="home"
                text={'บ้านเลขที่ ' + record.informFix.home.home_no}
              />
              {'  '}
              <IconText
                type="home"
                text={' แปลง ' + record.informFix.home.plan_no}
              />
            </div>
          ) : null}
          {record.technicians && record.technicians.length > 0 ? (
            <div>
              <IconText
                type="user"
                text={record.technicians ? technicianName(record) : null}
              />
            </div>
          ) : null}
          {record.created_at > 0 ? (
            <div>
              <IconText
                type="calendar"
                text={
                  record.created_at
                    ? '' + showTimeFromUnix(record.created_at)
                    : '-'
                }
              />
            </div>
          ) : null}
          {/* //////////////// */}
          {/* {record.job_status ? (
            <span>
             <JobStatus name={record.jobStatusName} statusId={record.job_status}/>
            </span>
          ) : null} */}
          {/* //////////////// */}
        </div>
      )
    }

    const columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        render: (id, row) => {
          return <React.Fragment>{id}</React.Fragment>
        },
      },
      {
        title: 'หมวดหมู่',
        key: 'group.name',
        dataIndex: 'group.name',
        render: (group, record) => {
          return <Tag>{record.group ? record.group.name : null}</Tag>
        },
      },
      {
        title: 'รายการ',
        dataIndex: 'list',
        key: 'list',
        render: (list, row) => {
          return (
            <React.Fragment>
              <div>{list ? <strong>{list}</strong> : null}</div>
              {row.description ? <p>{row.description}</p> : null}
              {showDetail(row)}
            </React.Fragment>
          )
        },
      },
      {
        title: 'เวลา',
        align: 'center',
        children: [
          {
            title: 'ตั้งแต่',
            dataIndex: 'start_time',
            key: 'start_time',
            align: 'center',
            render: (start_time, record) => {
              return (
                <JobDateTime
                  datetime={start_time}
                  jobStatus={record.job_status}
                />
              )
            },
          },
          {
            title: 'ถึง',
            dataIndex: 'end_time',
            key: 'end_time',
            align: 'center',
            render: (end_time, record) => {
              return (
                <JobDateTime
                  datetime={end_time}
                  jobStatus={record.job_status}
                />
              )
            },
          },
        ],
      },
      // {
      //   title: 'ช่าง',
      //   dataIndex: 'technicians',
      //   key: 'technicians',
      //   render: (technicians) =>
      //     technicians && technicians.length > 0 ? (
      //       <span>
      //         {technicians.map((t, index) => {
      //           let color = t.technician_id > 5 ? 'geekblue' : 'green'
      //           // if (t === 'loser') {
      //           //   color = 'volcano';
      //           // }
      //           return t.technician.firstname !== 'undefined' ? (
      //             <Tag color={color} key={t}>
      //               {t.technician.firstname.toUpperCase()}
      //             </Tag>
      //           ) : null
      //         })}
      //       </span>
      //     ) : null,
      // },
      {
        title: 'สถานะ',
        dataIndex: 'job_status',
        key: 'job_status2',
        render: (job_status, record) =>
          record.job_status ? (
            <JobStatus name={record.jobStatusName} statusId={job_status} />
          ) : null,
      },
      // {
      //   title: 'Action',
      //   dataIndex: 'action',
      //   key: 'action',
      //   render: (action, row) => {
      //     return (
      //       <React.Fragment>
      //        <Button>ปิดงาน</Button>
      //       </React.Fragment>
      //     )
      //   },
      // },
    ]

    return (
      <React.Fragment>
        {item ? (
          <div
            style={{
              margin: '0 auto',
              // backgroundColor: '',
              // color: '#ffffff',
            }}
          >
            <InformfixStatus
              name={item.workStatusName}
              statusId={item.work_status}
            />
            <Row align="top" gutter={[4, 4]}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 12 }}
              >
                <Row>
                  <Col className="gutter-row" span={10}>
                    <strong>เลขที่</strong>
                  </Col>
                  <Col className="gutter-row" span={14}>
                    {item ? item.code : item.code}
                  </Col>
                </Row>
                <Row>
                  <Col className="gutter-row" span={10}>
                    <strong>วันที่แจ้ง</strong>
                  </Col>
                  <Col className="gutter-row" span={14}>
                    {item.date_inform
                      ? showTimeFromUnix(item.date_inform)
                      : null}
                  </Col>
                </Row>
                <Row>
                  <Col className="gutter-row" span={10}>
                    <strong>เรื่อง</strong>
                  </Col>
                  <Col className="gutter-row" span={14}>
                    {item ? item.subject : item.subject}
                  </Col>
                </Row>
                <Row>
                  <Col className="gutter-row" span={10}>
                    <strong>รายละเอียด</strong>
                  </Col>
                  <Col className="gutter-row" span={14}>
                    {item ? item.description : item.description}
                  </Col>
                </Row>
                <Row>
                  <Col className="gutter-row" span={10}>
                    <strong>ผู้แจ้ง</strong>
                  </Col>
                  <Col className="gutter-row" span={14}>
                    {item ? item.informer : item.customer_name}
                  </Col>
                </Row>
                <Row>
                  <Col className="gutter-row" span={10}>
                    <strong>เวลาติดต่อกลับ</strong>
                  </Col>
                  <Col className="gutter-row" span={14}>
                    {item.contact_time ? item.contact_time : ''}
                  </Col>
                </Row>
                <Row>
                  <Col className="gutter-row" span={10}>
                    <strong>เบอร์โทร</strong>
                  </Col>
                  <Col className="gutter-row" span={14}>
                    {item.telephone ? item.telephone : item.contact_phone}
                  </Col>
                </Row>
                <Row>
                  <Col className="gutter-row" span={10}>
                    <strong>เวลาทำรายการ</strong>
                  </Col>
                  <Col className="gutter-row" span={14}>
                    {item ? showTimeFromUnix(item.created_at) : null}
                  </Col>
                </Row>
                {/* {item && photos && photos.length > 0
                    ? photos.map((x, xkey) => (
                        <ReactFancyBox
                          thumbnail={x.thumbnail}
                          image={x.url}
                          defaultThumbnailWidth={120}
                          defaultThumbnailHeight={120}
                        />
                      ))
                    : null} */}
                {/* {item.cover ? (
                  <div
                    style={{
                      padding: 2,
                    }}
                  >
                    <Image
                      preview={{ visible: false }}
                      width={200}
                      src={item.cover.thumbnail}
                      onClick={() => this.setVisibleGallery(true)}
                      alt={item.cover.description}
                    />
                  </div>
                ) : null} */}
 
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 12 }}
                lg={{ span: 12 }}
              >
                <Card
                  className="inform-card"
                  title=""
                  // style={{ height: 442 }}
                >
                  <Row>
                    <Col className="gutter-row" span={10}>
                      <strong>โครงการ</strong>
                    </Col>
                    <Col className="gutter-row" span={14}>
                      {item.project ? item.project.name : null}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="gutter-row" span={10}>
                      <strong>ประเภทบ้าน</strong>
                    </Col>
                    <Col className="gutter-row" span={14}>
                      {home && home.homeType ? home.homeType.name : null}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="gutter-row" span={10}>
                      <strong>บ้านเลขที่</strong>
                    </Col>
                    <Col className="gutter-row" span={14}>
                      {home ? home.home_no : null}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="gutter-row" span={10}>
                      <strong>แปลง</strong>
                    </Col>
                    <Col className="gutter-row" span={14}>
                      {home ? home.plan_no : null}
                    </Col>
                  </Row>
                  {/* <Row>
                    <Col className="gutter-row" span={10}>
                      <strong>ขนาดที่ดิน</strong>
                    </Col>
                    <Col className="gutter-row" span={14}>
                      {home ? home.land_size : '-'} ตารางวา
                    </Col>
                  </Row>
                  <Row>
                    <Col className="gutter-row" span={10}>
                      <strong>พื้นที่ใช้สอย</strong>
                    </Col>
                    <Col className="gutter-row" span={14}>
                      {home ? home.asset_area : '-'} ตารางเมตร
                    </Col>
                  </Row> */}
                  <Row>
                    <Col className="gutter-row" span={10}>
                      <strong>เจ้าของบ้าน/ลูกค้า</strong>
                    </Col>
                    <Col className="gutter-row" span={14}>
                      {item ? item.customer_name : '-'}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="gutter-row" span={10}>
                      <strong>วันที่โอนบ้าน</strong>
                    </Col>
                    <Col className="gutter-row" span={14}>
                      {home && home.warrantyExpired
                        ? Moment(home.warrantyExpired.transfer_date).format('LL')
                        : '-'}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="gutter-row" span={10}>
                      <strong>วันหมดประกัน</strong>
                    </Col>
                    <Col className="gutter-row" span={14}>
                      {home && home.warrantyExpired
                        ? Moment(home.warrantyExpired['1y']).format('LL')
                        : '-'}
                    </Col>
                  </Row>
                  <Row>
                    <Col className="gutter-row" span={10}>
                      <strong>วันหมดประกันโครงสร้าง</strong>
                    </Col>
                    <Col className="gutter-row" span={14}>
                      {home && home.warrantyExpired
                        ? Moment(home.warrantyExpired['5y']).format('LL')
                        : '-'}
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 24 }}
                lg={{ span: 24 }}
              >
             {item.images && item.images.length > 0 ? (
                  <div
                    style={{
                    marginBottom: 7
                    }}
                  >
                    <span style={{color: "yellow"}}>คลิ๊กที่รูป.. เพื่อดูแบบขยาย</span>
                    <Image.PreviewGroup
                      preview={{
                        visible: visibleGallery,
                        onVisibleChange: (vis) => this.setVisibleGallery(vis),
                      }}
                    >
                      <Row gutter={8}>
                      {item.images.map((img, imgKey) => (
                        <Col><Image src={img.url} key={imgKey} alt={img.description} width={100} height={100} style={{margin: 5}}/></Col>
                      ))}
                      </Row>
                    </Image.PreviewGroup>
                  </div>
                ) : null}
                <article
                  style={{
                    backgroundColor: '#ffffff',
                    padding: 7,
                    color: '#222222',
                  }}
                >
                  <h3
                    style={{
                      fontSize: '1.2rem',
                    }}
                  >
                    รายละเอียดงาน
                  </h3>
                  {/* <Card
                  className="inform-card"
                  title="ตารางคิวงาน"
                  style={{ minHeight: 317 }}
                  bodyStyle={{
                    padding: 10,
                  }}
                > */}
                  {jobs && jobs.length > 0 ? (
                    <React.Fragment>
                    {/* <Table
                      bordered
                      size="small"
                      dataSource={jobs}
                      columns={columns}
                      pagination={false}
                      rowKey={(i) => {
                        return i.id
                      }}
                    /> */}
                      {jobs.map((job, key) => (
                        <JobItem job={job} key={key} />
                      ))}
                    </React.Fragment>
                  ) : (
                    <Empty />
                  )}
                  {/* </Card> */}
                </article>
              </Col>
            </Row>
          </div>
        ) : null}
      </React.Fragment>
    )
  }
}

export default InformView
